// Ensures project/context terms exist, then applies the triage drop handler.
import { ensureTermsExist } from '@/services/tagService';
import { resolveDndTaskId } from '@/features/tasks/utils/interactions/dragHandlers';
import { DROP_HANDLERS_BY_GROUP_KEY } from '@/features/organize/utils/inboxDropHandlers';

async function ensureProjectZoneTerm({
  overId,
  user,
  pendingProjectNames,
  projectDisplayMap,
}) {
  if (!overId.startsWith('triage-project-')) return;
  const projectId = overId.replace('triage-project-', '');
  const displayName =
    pendingProjectNames.get(projectId) ??
    projectDisplayMap.get(projectId) ??
    projectId;
  if (projectId === 'untagged') return;
  await ensureTermsExist(
    [projectId],
    'projects',
    user.uid,
    new Map([[projectId, displayName]]),
  );
}

async function ensureContextZoneTerm({
  overId,
  user,
  pendingContextNames,
  contextDisplayMap,
}) {
  if (!overId.startsWith('triage-context-')) return;
  const contextId = overId.replace('triage-context-', '');
  const displayName =
    pendingContextNames.get(contextId) ??
    contextDisplayMap.get(contextId) ??
    contextId;
  if (contextId === 'untagged') return;
  await ensureTermsExist(
    [contextId],
    'contexts',
    user.uid,
    new Map([[contextId, displayName]]),
  );
}

export async function applyInboxZoneAssign({
  taskId,
  zoneId,
  user,
  updateTask,
  activeGroupKey,
  pendingProjectNames,
  projectDisplayMap,
  pendingContextNames,
  contextDisplayMap,
}) {
  if (!user || !taskId || zoneId === null || zoneId === undefined) return;

  const overId = String(zoneId);
  const groupKey = activeGroupKey;

  if (groupKey === 'project') {
    await ensureProjectZoneTerm({
      overId,
      user,
      pendingProjectNames,
      projectDisplayMap,
    });
  }
  if (groupKey === 'context') {
    await ensureContextZoneTerm({
      overId,
      user,
      pendingContextNames,
      contextDisplayMap,
    });
  }

  const applyDrop = DROP_HANDLERS_BY_GROUP_KEY[groupKey];
  if (applyDrop) applyDrop(overId, taskId, user, updateTask);
}

export async function applyInboxDragEnd({
  active,
  over,
  user,
  updateTask,
  activeGroupKey,
  pendingProjectNames,
  projectDisplayMap,
  pendingContextNames,
  contextDisplayMap,
}) {
  if (!over || !user) return;

  const taskId = resolveDndTaskId(active);
  await applyInboxZoneAssign({
    taskId,
    zoneId: over.id,
    user,
    updateTask,
    activeGroupKey,
    pendingProjectNames,
    projectDisplayMap,
    pendingContextNames,
    contextDisplayMap,
  });
}
